export default __webpack_public_path__ + "static/media/corredor_con_logo_Dashport.429c6f77.webp";